export default __webpack_public_path__ + "e941872262a60140e5258f7a1d7aca2a.woff";